import "crypto-js/lib-typedarrays";

import { Link } from "react-router-dom";

import AuthLayout from "../layout/AuthLayout";
import SigninForm from "./SigninForm";

function SigninScreen() {
	return (
		<AuthLayout>
			<Link to="/" className="mb-10 block md:hidden">
				<img src="/images/logo.png" alt="DProz Logo" className="mx-auto w-[140px]" />
			</Link>
			<header className="mb-8">
				<h2 className="font-plus-jakarta text-2xl font-bold text-gray-900">Welcome back</h2>
				<p className="mt-2 text-[15px] leading-relaxed text-gray-600">Log in to see the latest jobs matched to you.</p>
			</header>
			<SigninForm />
		</AuthLayout>
	);
}

export default SigninScreen;
